<div
    class="slide-out-panel"
    #slideOutPanel>
    <div class="panel-header">
        {{ title }}
        <mat-icon
            class="close-icon"
            (click)="close()"
            >close</mat-icon
        >
    </div>
    <div class="panel-body">
        <span class="bold">Please choose a reason for declining this offer. </span>
        <br />
        <span>Fields marked with an [*] are required</span>
        <form
            [formGroup]="offerDeclineFormGroup"
            (ngSubmit)="onSubmit()">
            <span class="reason-span">Reason*</span>
            <mat-accordion
                class="nova__expansion"
                [multi]="false">
                <mat-expansion-panel *ngFor="let category of uniqueCategories">
                    <mat-expansion-panel-header (click)="filterReasonsByCategoryId(category.categoryId)">
                        <mat-panel-title class="category-name">
                            {{ category.categoryName }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ul class="options">
                        <mat-radio-group
                            formControlName="selectedReason"
                            (change)="reasonSelection($event)">
                            <li *ngFor="let option of filteredReasons">
                                <mat-radio-button
                                    [value]="option"
                                    [checked]="offerDeclineFormGroup.get('selectedReason')?.value?.id === option.id"
                                    (click)="resetForm()">
                                    {{ option.name }}
                                </mat-radio-button>
                                <div
                                    *ngIf="
                                        offerDeclineFormGroup.get('reasonId')?.value === option.id &&
                                        (offerDeclineFormGroup.get('reasonId')?.value === reasonEnum.SigningAya ||
                                            offerDeclineFormGroup.get('reasonId')?.value ===
                                                reasonEnum.SigningDifferentFacility ||
                                            offerDeclineFormGroup.get('reasonId')?.value ===
                                                reasonEnum.SigningThisFacility)
                                    ">
                                    <div
                                        *ngIf="
                                            offerDeclineFormGroup.get('reasonId')?.value ===
                                                reasonEnum.SigningDifferentFacility ||
                                            offerDeclineFormGroup.get('reasonId')?.value ===
                                                reasonEnum.SigningThisFacility
                                        ">
                                        <div class="form-row">
                                            <div class="form-field form-field--left custom-center">
                                                <span class="label-text label-text--center">Agency*</span>
                                            </div>
                                            <div class="form-field form-field--right">
                                                <mat-form-field appearance="outline">
                                                    <input
                                                        type="text"
                                                        placeholder="Choose an Agency*"
                                                        matInput
                                                        formControlName="vendorId"
                                                        [matAutocomplete]="autoAgency"
                                                        data-qa-id="AgencyIdInput" />
                                                    <mat-icon
                                                        matSuffix
                                                        *ngIf="!isAgencyLoading">
                                                        search
                                                    </mat-icon>
                                                    <mat-autocomplete
                                                        #autoAgency="matAutocomplete"
                                                        [displayWith]="checkValue">
                                                        <mat-option
                                                            *ngFor="let option of incomingDeclineData.vendorOptions"
                                                            [value]="option"
                                                            class="option-multi-line"
                                                            [matTooltip]="option.legalName"
                                                            matTooltipPosition="right"
                                                            [matTooltipShowDelay]="500">
                                                            {{ option.legalName }}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                    <mat-progress-spinner
                                                        *ngIf="isAgencyLoading"
                                                        matSuffix
                                                        mode="indeterminate"
                                                        strokeWidth="2"
                                                        diameter="24">
                                                    </mat-progress-spinner>
                                                    <mat-error>Choose an option</mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div
                                            class="form-row"
                                            *ngIf="
                                                offerDeclineFormGroup.get('vendorId')?.value?.id === vendorEnum.Other
                                            ">
                                            <div class="form-field form-field--left"></div>
                                            <div class="form-field form-field--right">
                                                <mat-form-field appearance="outline">
                                                    <input
                                                        matInput
                                                        type="text"
                                                        placeholder="Type an Agency"
                                                        formControlName="vendorName"
                                                        data-qa-id="VendorNameInput" />
                                                    <mat-error>Type an agency</mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-field form-field--left">
                                            <span class="label-text label-text--center"
                                                >{{ subReasonQuestionLabel }}</span
                                            >
                                        </div>
                                        <div class="form-field form-field--right">
                                            <mat-form-field
                                                *ngIf="option.subReasons.length > 0"
                                                appearance="outline">
                                                <mat-select
                                                    multiple
                                                    formControlName="subReasonIds"
                                                    placeholder="Select one or more reasons*"
                                                    data-qa-id="SubReasonIdsInput">
                                                    <mat-select-trigger>
                                                        {{ selectedSubReasonsText }}
                                                    </mat-select-trigger>
                                                    <mat-option
                                                        #subReasonOption
                                                        *ngFor="let reason of option.subReasons || []"
                                                        [value]="reason"
                                                        [disabled]="checkSubReasonDisabled(subReasonOption)"
                                                        (onSelectionChange)="subReasonSelect($event, subReasonOption)">
                                                        {{ reason.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Make at least 1 selection</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="chips-container">
                                        <mat-chip-list
                                            aria-label="Decline Sub Reasons"
                                            class="sub-chips">
                                            <mat-chip
                                                disableRipple
                                                *ngFor="
                                                    let sub of offerDeclineFormGroup.get('subReasonIds').value || []
                                                ">
                                                {{ sub.name }}
                                            </mat-chip>
                                        </mat-chip-list>
                                    </div>
                                    <div
                                        class="form-row"
                                        *ngIf="showOtherTextField">
                                        <div class="form-field form-field--left custom-center">
                                            <span class="label-text label-text--center">Other*</span>
                                        </div>
                                        <div class="form-field form-field--right">
                                            <mat-form-field appearance="outline">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Other Reason*"
                                                    matInput
                                                    formControlName="otherReasonText"
                                                    data-qa-id="OtherReasonInput" />
                                                <mat-error>Provide other reason</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div
                                        class="form-row form-row-pay form-row--align-center"
                                        *ngIf="showPayFields">
                                        <div class="form-field form-field--left">
                                            <span class="label-text">Enter Pay*</span>
                                        </div>
                                        <div class="form-field form-field--right">
                                            <mat-radio-group
                                                aria-label="Enter Pay"
                                                class="pay-radio-group"
                                                formControlName="pay"
                                                data-qa-id="PayInput">
                                                <div class="radio-item">
                                                    <mat-radio-button value="1"></mat-radio-button>
                                                    <mat-form-field
                                                        appearance="outline"
                                                        floatLabel="never"
                                                        class="pay-form-field">
                                                        <input
                                                            matInput
                                                            type="text"
                                                            formControlName="payRate"
                                                            data-qa-id="PayRateInput" />
                                                        <mat-select
                                                            formControlName="payFreq"
                                                            data-qa-id="PayFreqInput">
                                                            <mat-option value="week">/wk</mat-option>
                                                            <mat-option value="hour">/hr</mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="
                                                                offerDeclineFormGroup.get('payRate')?.invalid &&
                                                                offerDeclineFormGroup.get('payRate').touched
                                                            ">
                                                            Enter a valid Pay Rate
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="radio-item">
                                                    <mat-radio-button value="0">Unknown</mat-radio-button>
                                                </div>
                                            </mat-radio-group>
                                            <mat-error *ngIf="offerDeclineFormGroup.get('pay').invalid">
                                                Select an option
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div
                                        class="form-row form-row-candidate"
                                        *ngIf="
                                            offerDeclineFormGroup.get('reasonId')?.value === option.id &&
                                            (offerDeclineFormGroup.get('reasonId')?.value ===
                                                reasonEnum.SigningDifferentFacility ||
                                                offerDeclineFormGroup.get('reasonId')?.value ===
                                                    reasonEnum.SigningThisFacility)
                                        ">
                                        <div class="form-field form-field--left">
                                            <span class="label-text">Candidate was*</span>
                                        </div>
                                        <div class="form-field form-field--right">
                                            <mat-radio-group
                                                formControlName="isExistingVendorForCandidate"
                                                class="candidate-radio-group">
                                                <mat-radio-button [value]="true">
                                                    Existing to this agency
                                                </mat-radio-button>
                                                <mat-radio-button [value]="false">
                                                    New to this agency
                                                </mat-radio-button>
                                            </mat-radio-group>
                                            <mat-error
                                                *ngIf="
                                                    offerDeclineFormGroup.get('isExistingVendorForCandidate').invalid &&
                                                    offerDeclineFormGroup.get('isExistingVendorForCandidate').touched
                                                "
                                                class="error-msg">
                                                Select an option
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="
                                            offerDeclineFormGroup.get('reasonId')?.value === option.id &&
                                            (offerDeclineFormGroup.get('reasonId')?.value === reasonEnum.SigningAya ||
                                                offerDeclineFormGroup.get('reasonId')?.value ===
                                                    reasonEnum.SigningDifferentFacility)
                                        ">
                                        <div class="form-row">
                                            <div class="form-field form-field--left custom-center">
                                                <span class="label-text label-text--center">Facility*</span>
                                            </div>
                                            <div class="form-field form-field--right">
                                                <mat-form-field appearance="outline">
                                                    <input
                                                        type="text"
                                                        placeholder="Choose Facility*"
                                                        matInput
                                                        formControlName="facilityId"
                                                        [matAutocomplete]="autoFacility"
                                                        data-qa-id="FacilityIdInput" />
                                                    <mat-icon
                                                        matSuffix
                                                        *ngIf="!isFacilityLoading">
                                                        search
                                                    </mat-icon>
                                                    <mat-autocomplete
                                                        #autoFacility="matAutocomplete"
                                                        [displayWith]="checkFacilityValue">
                                                        <mat-option
                                                            *ngFor="let option of incomingDeclineData.facilityOptions"
                                                            [value]="option"
                                                            class="option-multi-line"
                                                            [matTooltip]="option.name"
                                                            matTooltipPosition="right"
                                                            [matTooltipShowDelay]="500">
                                                            {{ option.name }}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                    <mat-error>Choose an option</mat-error>
                                                    <mat-progress-spinner
                                                        *ngIf="isFacilityLoading"
                                                        matSuffix
                                                        mode="indeterminate"
                                                        strokeWidth="2"
                                                        diameter="24">
                                                    </mat-progress-spinner>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div
                                            class="form-row"
                                            *ngIf="
                                                offerDeclineFormGroup.get('facilityId')?.value?.id === vendorEnum.Other
                                            ">
                                            <div class="form-field form-field--left"></div>
                                            <div class="form-field form-field--right">
                                                <mat-form-field appearance="outline">
                                                    <input
                                                        matInput
                                                        type="text"
                                                        placeholder="Type a Facility"
                                                        formControlName="facilityName"
                                                        data-qa-id="FacilityNameInput" />
                                                    <mat-error>Type a facility</mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </mat-radio-group>
                    </ul>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-divider class="custom-divider"></mat-divider>
            <div class="form-row form-textarea">
                <div class="form-field form-field--left field--textarea">
                    <span class="label-text label-text--center">Comment <br />(Optional)</span>
                </div>
                <div class="form-field form-field--right">
                    <mat-form-field appearance="outline">
                        <textarea
                            matInput
                            rows="6"
                            formControlName="reasonText"
                            class="comments-textarea"
                            data-qa-id="ReasonTextInput">
                        </textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div class="panel-footer">
        <mat-dialog-actions class="nova__dialog__content__actions">
            <button
                type="submit"
                (click)="onSubmit()"
                mat-raised-button
                color="primary">
                DECLINE OFFER
            </button>
            <button
                mat-raised-button
                color="default"
                (click)="close()">
                CANCEL
            </button>
        </mat-dialog-actions>
    </div>
</div>
